"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OpenModal = OpenModal;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_1 = require("react");
const Modal_1 = require("./Modal");
const useModal_1 = require("./useModal");
/**
 * A component for testing open modals in stories and unit tests.
 *
 * Currently, calling `render(<ModalComponent />)` in a test currently doesn't work, because
 * nothing has called `useModal` to get the header & footer mounted into the DOM.
 *
 * So instead tests can call:
 *
 * ```tsx
 * render(
 *   <OpenModal>
 *     <ModalComponent />
 *   </OpenModal>
 * );
 * ```
 *
 * And `OpenModal` will do a boilerplate `openModal` call, so that the content
 * shows up in the DOM as expected.
 */
function OpenModal(props) {
    const { openModal } = (0, useModal_1.useModal)();
    const { size, children, keepOpen } = props;
    (0, react_1.useEffect)(() => {
        if (!keepOpen) {
            openModal({ size, content: children });
        }
    }, [keepOpen, openModal, size, children]);
    if (keepOpen) {
        return (0, jsx_runtime_1.jsx)(Modal_1.Modal, { size: size, content: children });
    }
    else {
        return (0, jsx_runtime_1.jsx)("div", { children: "dummy content" });
    }
}
